import {
  FETCH_LOANTRANSACTIONS,
  FETCH_LOANTRANSACTIONS_SUCCESS,
  FETCH_LOANTRANSACTIONS_FAILURE,
} from '../../actions/loanActions'

const intialLoanTransactionsState = {
  data: [],
  loading: false,
}

const loanTransactionsReducer = (
  state = intialLoanTransactionsState,
  action
) => {
  switch (action.type) {
    case FETCH_LOANTRANSACTIONS:
      return {
        ...state,
        loading: true,
      }
    case FETCH_LOANTRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case FETCH_LOANTRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}

export default loanTransactionsReducer
